import { initSliders } from './components/sliders';
import { initHotspots } from './components/hotspot';
import { initMap } from './components/osm';
import { initVideoPlayer } from './components/video';
import { navigationDropdown } from './components/navigation';
import { initLoadAllSpecs } from './components/load_all';
import { initMobileNav } from './components/mobile-nav';
import { initStickyHeader } from './components/header';

navigationDropdown();
initSliders();
initHotspots();
initMap();
initVideoPlayer();
initLoadAllSpecs();
initMobileNav();
initStickyHeader();
